// Action type constants
export const SET_SELECTED_ASSET_ID = 'editorSelection/SET_SELECTED_ASSET_ID';
export const SET_SELECTED_CLIP_ID = 'editorSelection/SET_SELECTED_CLIP_ID';
export const SET_SELECTED_KEYFRAME_ID = 'editorSelection/SET_SELECTED_KEYFRAME_ID';
export const SET_SELECTED_TRIGGER_ID = 'editorSelection/SET_SELECTED_TRIGGER_ID';
export const SET_HOVERED_TRIGGER_ID = 'editorSelection/SET_HOVERED_TRIGGER_ID';
export const SET_TRIGGER_AFFECTING_MODE_ID = 'editorSelection/SET_TRIGGER_AFFECTING_MODE_ID';
export const SET_SELECTED_REACTIVE_ASSET_ID = 'editorSelection/SET_SELECTED_REACTIVE_ASSET_ID';
export const SET_IS_CREATING_KEYFRAME = 'editorSelection/SET_IS_CREATING_KEYFRAME';
export const SET_IS_SELECTING_CLIP = 'editorSelection/SET_IS_SELECTING_CLIP';
export const SET_IS_ORBIT_VIEW = 'editorSelection/SET_IS_ORBIT_VIEW';
export const SET_IS_BLADE_MODE = 'editorSelection/SET_IS_BLADE_MODE';

export interface EditorSelectionState {
  selectedAssetId: string | null;
  selectedClipId: string | null;
  selectedKeyframeId: string | null;
  selectedTriggerId: string | null;
  // Gate highlighted by hovering its row card (panel/timeline), independent of selection.
  hoveredTriggerId: string | null;
  // Gate whose affected-assets are being picked in the timeline; null = not in mode.
  triggerAffectingModeId: string | null;
  // Affected asset whose reactive-clip pill is selected (gate stays selected too).
  selectedReactiveAssetId: string | null;
  isCreatingKeyframe: boolean;
  isSelectingClip: boolean;
  isOrbitView: boolean;
  // Blade tool armed: razor cursor on media rows, click-anywhere to split.
  isBladeMode: boolean;
}

export interface SetSelectedAssetIdAction {
  type: typeof SET_SELECTED_ASSET_ID;
  payload: string | null;
}

export interface SetSelectedClipIdAction {
  type: typeof SET_SELECTED_CLIP_ID;
  payload: string | null;
}

export interface SetSelectedKeyframeIdAction {
  type: typeof SET_SELECTED_KEYFRAME_ID;
  payload: string | null;
}

export interface SetSelectedTriggerIdAction {
  type: typeof SET_SELECTED_TRIGGER_ID;
  payload: string | null;
}

export interface SetHoveredTriggerIdAction {
  type: typeof SET_HOVERED_TRIGGER_ID;
  payload: string | null;
}

export interface SetTriggerAffectingModeIdAction {
  type: typeof SET_TRIGGER_AFFECTING_MODE_ID;
  payload: string | null;
}

export interface SetSelectedReactiveAssetIdAction {
  type: typeof SET_SELECTED_REACTIVE_ASSET_ID;
  payload: string | null;
}

export interface SetIsCreatingKeyframeAction {
  type: typeof SET_IS_CREATING_KEYFRAME;
  payload: boolean;
}

export interface SetIsSelectingClipAction {
  type: typeof SET_IS_SELECTING_CLIP;
  payload: boolean;
}

export interface SetIsBladeModeAction {
  type: typeof SET_IS_BLADE_MODE;
  payload: boolean;
}

export type EditorSelectionActionTypes =
  | SetSelectedAssetIdAction
  | SetSelectedClipIdAction
  | SetSelectedKeyframeIdAction
  | SetSelectedTriggerIdAction
  | SetHoveredTriggerIdAction
  | SetTriggerAffectingModeIdAction
  | SetSelectedReactiveAssetIdAction
  | SetIsCreatingKeyframeAction
  | SetIsSelectingClipAction
  | SetIsBladeModeAction
  | SetIsOrbitViewAction;

export interface SetIsOrbitViewAction {
  type: typeof SET_IS_ORBIT_VIEW;
  payload: boolean;
}

// Action creators
export const setSelectedAssetId = (id: string | null): SetSelectedAssetIdAction => ({
  type: SET_SELECTED_ASSET_ID,
  payload: id,
});

export const setSelectedClipId = (id: string | null): SetSelectedClipIdAction => ({
  type: SET_SELECTED_CLIP_ID,
  payload: id,
});

export const setSelectedKeyframeId = (id: string | null): SetSelectedKeyframeIdAction => ({
  type: SET_SELECTED_KEYFRAME_ID,
  payload: id,
});

export const setSelectedTriggerId = (id: string | null): SetSelectedTriggerIdAction => ({
  type: SET_SELECTED_TRIGGER_ID,
  payload: id,
});

export const setHoveredTriggerId = (id: string | null): SetHoveredTriggerIdAction => ({
  type: SET_HOVERED_TRIGGER_ID,
  payload: id,
});

export const setTriggerAffectingModeId = (id: string | null): SetTriggerAffectingModeIdAction => ({
  type: SET_TRIGGER_AFFECTING_MODE_ID,
  payload: id,
});

export const setSelectedReactiveAssetId = (id: string | null): SetSelectedReactiveAssetIdAction => ({
  type: SET_SELECTED_REACTIVE_ASSET_ID,
  payload: id,
});

export const setIsCreatingKeyframe = (isCreating: boolean): SetIsCreatingKeyframeAction => ({
  type: SET_IS_CREATING_KEYFRAME,
  payload: isCreating,
});

export const setIsSelectingClip = (isSelecting: boolean): SetIsSelectingClipAction => ({
  type: SET_IS_SELECTING_CLIP,
  payload: isSelecting,
});

export const setIsOrbitView = (isOrbitView: boolean): SetIsOrbitViewAction => ({
  type: SET_IS_ORBIT_VIEW,
  payload: isOrbitView,
});

export const setIsBladeMode = (isBladeMode: boolean): SetIsBladeModeAction => ({
  type: SET_IS_BLADE_MODE,
  payload: isBladeMode,
});
